<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Work Group Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="work_group.name">
      <template #right-content>
        <header-button-group :button_config="button_config">
          <template #post_buttons>
            <button
              v-show="checkPermission('delete work group')"
              title="Delete work group"
              class="btn btn-danger ml-1"
              @click="showDeleteModal"
            >
              <i class="fal fa-trash" />
            </button>
          </template>
        </header-button-group>
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'read work group'">
      <template #gated-content>
        <work-group-card v-if="work_group_id" :work_group="work_group" />
        <work-group-detail-cardstack :work_group="work_group" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import WorkGroupCard from "@/components/lab/workgroup/WorkGroupCard";
import WorkGroupDetailCardstack from "@/components/lab/workgroup/WorkGroupDetailCardstack";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { notificationOptions } from "@/shared/toast-notification-options";
import { workGroupNotifications } from "@/shared/notifications";
import { getModel } from "@/shared/fetch-utils";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

Vue.use(VueNotifications, notificationOptions);

const WorkGroupRepository = LabRepositoryFactory.get("workGroup");

export default {
  name: "WorkGroupDetail",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    WorkGroupCard,
    WorkGroupDetailCardstack,
    PermissionAlertGate,
  },
  mixins: [ToastNotifications],
  data() {
    return {
      loading: true,
      work_group_id: this.$route.params.work_group_id || null,
      work_group: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/workgroups",
            title: "Work Group list",
          },
          {
            icon: "fa-pencil",
            linkto: `/workgroups/${this.work_group_id}/edit`,
            title: "Edit Work Group",
            variant: "warning",
            permission: this.checkPermission("edit work group"),
          },
        ],
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    showDeleteModal() {
      this.$bvModal
        .msgBoxConfirm(
          "You are about to remove this work group. Do you want to continue?",
          {
            title: "Are you sure?",
            modalClass: ["modal-danger"],
            size: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            centered: true,
          }
        )
        .then(async (confirm) => {
          if (confirm) {
            try {
              await WorkGroupRepository.suspend(this.work_group_id);
  
              this.deleteSuccess();
              this.$router.push("/workgroups");
            } catch ({ response }) {
              const { status, data } = response.response;
  
              this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
                title: "Server Error.",
                variant: "danger",
              });
            }           
          }
        });
    },
  },
  async created() {
    this.loading = true;

    this.work_group = await getModel({
      model_type: "work_group",
      id: this.work_group_id,
      message: this.$bvToast,
    });

    this.work_group ? (this.loading = false) : this.$router.back();
  },
  notifications: workGroupNotifications
}
</script>